import { Box, Button, Card, CardContent, Checkbox, Container, FormControlLabel, Grid, Link, TextField, Typography } from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import JA, { API_URL } from "../../../api/api";
import logo from "../../../assets/img/logo.png";
import AddAlertMessage from "../../../components/alert/Alert";
import Spinner from "../../../components/loader/Loader";
// context
import { useUserDispatch } from "../../../context/UserContext";
import { AppMisc } from "../../../misc/appMisc";
import { ENTER_VALID_EMAIL, IS_SESSION_EXPIRED, LOGIN_FAILURE, LOGIN_SUCCESS, PALIKA_NAME, REQUIRED_FIELD, SESSION_EXPIRED, SOMETHING_WENT_WRONG, SUCCESS, USER_ROLE } from "../../../utils/constants/index";
import { Cookies } from "../../../utils/storage/cookies";
import { SessionStorage } from "../../../utils/storage/sessionStorage";
import styles from "./style";

export default function LoginForm(props) {
  const classes = styles();
  const { register, handleSubmit, errors } = useForm();
  let palikaName = SessionStorage.getItem(PALIKA_NAME);

  // global
  var userDispatch = useUserDispatch();

  // local
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (SessionStorage.getItem(IS_SESSION_EXPIRED) === "true") {
      AddAlertMessage({
        type: "error",
        message: SESSION_EXPIRED
      });
      SessionStorage.removeItem(IS_SESSION_EXPIRED);
    }
  }, []);

  const onSubmit = data => {
    setIsLoading(true);
    data.userEmail = data.userEmail.toLowerCase().trim();
    JA.post(API_URL.login, data)
      .then(response => {
        setIsLoading(false);
        let data = response.data;
        if (data.type === SUCCESS) {
          let userRole = Cookies.readCookie(USER_ROLE);
          !userRole && data && Cookies.writeCookie(USER_ROLE, data.data, 6 * 24);
          userDispatch({ type: LOGIN_SUCCESS });
          props.history.push("/");
        } else {
          userDispatch({ type: LOGIN_FAILURE });
          AddAlertMessage({ type: data.type, message: data.message });
        }
      })
      .catch(error => {
        setIsLoading(false);
        AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
        userDispatch({ type: LOGIN_FAILURE });
      });
  };

  return (
    <Container maxWidth="sm" className={classes.root}>
      <Box textAlign="center" my={3}>
        <img src={logo} alt="JA Logo" width="124" />
        <Box fontSize="h5.fontSize">जन-आवाज</Box>
        <Typography>{palikaName ? AppMisc.getMunicipalityName(palikaName) + " - " : ""}गुनासो व्यवस्थापन प्रणाली</Typography>
      </Box>
      <Card>
        <CardContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="userEmail"
                label="ईमेल"
                margin="normal"
                variant="outlined"
                name="userEmail"
                inputRef={register({
                  required: true,
                  pattern: /\S+@\S+\.\S+/
                })}
              />
              {errors.userEmail && errors.userEmail.type === "required" && (<span className="error-message">{REQUIRED_FIELD}</span>)}
              {errors.userEmail && errors.userEmail.type === "pattern" && (<span className="error-message">{ENTER_VALID_EMAIL}</span>)}
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="password"
                label="पासवर्ड"
                type="password"
                autoComplete="current-password"
                margin="normal"
                variant="outlined"
                name="password"
                inputRef={register({
                  required: true
                })}
              />
              {errors.password && (
                <span className="error-message">{REQUIRED_FIELD}</span>
              )}
            </Grid>
            <FormControlLabel
              control={<Checkbox color="primary" />}
              label="मलाई सम्झनुहोस्।"
              name="rememberMe"
              inputRef={register}
            />
            <Grid item xs={12} className={classes.loginBtnContainer}>
              {isLoading ? (
                <Spinner />
              ) : (
                <Button
                  endIcon={<ExitToAppIcon />}
                  size="large"
                  fullWidth
                  color="primary"
                  variant="contained"
                  type="submit"
                >
                  साइन इन गर्नुहोस्
                </Button>
              )}
            </Grid>
          </form>
        </CardContent>
      </Card>
      <Box display="flex" justifyContent="space-between" pt={1}>
        <Link
          href={AppMisc.getHomePageURLFromPalikaName(palikaName)}
          underline="none"
        >
          वेबसाइट गृहपृष्ठमा जानुहोस्
        </Link>
        <Link
          href="/forget-password"
          underline="none"
          color="textSecondary"
          className={classes["forget-password-label"]}
        >
          पासवर्ड बिर्सनु भयो ?
        </Link>
      </Box>
    </Container>
  );
}
